export type WinningOutcomeMotif = "checkmate" | "win_by_resignation" | "win_on_time";

export const winningOutcomeMotif = (result: string, termination: string | null): WinningOutcomeMotif | null => {
  if (result !== "win" || !termination) return null;
  const finish = termination.toLowerCase();
  if (finish.includes("checkmate")) return "checkmate";
  if (finish.includes("resign")) return "win_by_resignation";
  if (finish.includes("time")) return "win_on_time";
  return null;
};

export const winningOutcomeLabel = (motif: WinningOutcomeMotif): string =>
  motif === "checkmate" ? "CHECKMATE" : motif === "win_by_resignation" ? "WIN BY RESIGNATION" : "WIN ON TIME";
